exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".project .hero{height:100vh;position:fixed;top:0;right:0;left:0;z-index:1}.project .page-content-hldr{position:relative;top:100vh;z-index:2;background:#202020}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-Project/_index.scss
 ** module id = 198
 ** module chunks = 0
 **/